import { Alert, Box, Button } from "@mui/material";
import { isRouteErrorResponse, Link as RouterLink, useRouteError } from "react-router";

import { useLabel } from "../../translations/use-label";
import { routePaths } from "../../routes/route-paths";

export function RouteErrorScreen(): React.JSX.Element {
  const routeError = useRouteError();
  const getLabel = useLabel();
  const errorText = isRouteErrorResponse(routeError) ? `${routeError.status} ${routeError.statusText}` : getLabel("errors.unexpected");

  return (
    <Box sx={{ p: 4, maxWidth: 640, mx: "auto" }}>
      <Alert
        severity="error"
        action={
          <Button color="inherit" size="small" component={RouterLink} to={routePaths.dashboard}>
            {getLabel("navigation.dashboard")}
          </Button>
        }
      >
        {errorText}
      </Alert>
    </Box>
  );
}
